var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.load)?_c('div',{staticClass:"loader-ring"}):(_vm.img)?_c('img',{staticStyle:{"margin":"0 auto","width":"200px","height":"auto","display":"block"},attrs:{"src":("data:image/jpg;base64," + _vm.img)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }